export default __webpack_public_path__ + "static/media/gum3.1b619107.png";